import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";

export class ConfigRepository {
	constructor() {
		let host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async loadSystemConfig() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/systemconfig"), method: "GET", token: null, throwOnNonOk: false });
			if (!response.ok) {
				console.log("Error cargando configuración del sistema");
				return response.status;
			}
			const configResult = response.data;
			if (configResult.result === 0) {
				return configResult;
			} else {
				console.log("Error cargando configuración del sistema");
			}
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo la configuración.");
		}
	}

	async getLogicalDate() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/config/logical-date"), method: "POST", throwOnNonOk: false });
			if (!response.ok) {
				console.error("Error obteniendo la fecha lógica del sistema", response.status);
				return null;
			}
			const result = response.data;
			if (result && result.result === 0 && result.logicalDate) {
				return result.logicalDate;
			} else {
				console.error("Error obteniendo la fecha lógica del sistema", result);
				return null;
			}
		} catch (e) {
			console.error("Ups, algo ha ido mal obteniendo la fecha lógica.", e);
			return null;
		}
	}

	/**
	 * Bundled config endpoint: systemConfig + venueConfig + logicalDate in one call.
	 * Replaces separate loadSystemConfig + loadVenueConfig calls.
	 */
	async getAppConfig() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/config"), method: "GET", token: null, throwOnNonOk: false });
			if (!response.ok) {
				console.error("Error loading app config", response.status);
				return null;
			}
			const result = response.data;
			if (result && result.result === 0) {
				return result;
			}
			console.error("Error loading app config", result);
			return null;
		} catch (e) {
			console.error("Error loading app config", e);
			return null;
		}
	}
}

export const configRepository = new ConfigRepository();
